module.exports = "https://staticsandbox.coteibem.com.br/assets/logo-color-dark-horizontal.c412b4d89508416b62fce82cf5c7a972.svg";